@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<div id="payment-error" [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <h2>{{ 'payment_result.error.title' | translate }}</h2>
    <p>{{ 'payment_result.error.message' | translate }}</p>
    <app-button routerLink="/dashboard">{{ 'payment_result.buttons.back_to_dashboard' | translate }}</app-button>
</div>